import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ArticleChangedService {
  private _articleChanged$ = new Subject<{ articleUsageId: string, updateTextures: boolean }>();

  public get articleChanged$(): Observable<{ articleUsageId: string, updateTextures: boolean }> {
    return this._articleChanged$.asObservable();
  }

  public articleChanged(articleUsageId: string, updateTextures: boolean): void {
    this._articleChanged$.next({ articleUsageId, updateTextures });
  }
}
